import { useRef } from 'react';

let id = 0;
export function _useId(): string {
	// const ref = useId();

	const ref = useRef<string>();
	if (!ref.current) {
		let x = id++;
		ref.current = ':r' + x.toString() + ':';
		//----- the following returns the same as useId() in React
		// let s = '';
		// while(true){
		//     const y = x % 32;
		//     s = table.charAt(y)+s;
		//     x = Math.floor(x / 32);
		//     if(x <= 0)
		//         break;
		// }
		// const ret = ':r'+s+':';
		// if(ref !== ret){
		//     debugger;
		// }
		// return ret;
	}
	return ref.current;
}

//  const table = '0123456789abcdefghijklmnopqrstuvw';
